import React, { useState } from 'react';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SaveIcon from '@material-ui/icons/Save';
import { PopupModal } from '../../../Modals/Index';
import './style.css';
import { SendMail } from '../..';
import { AddressDetailsPreview } from '../../../Components';

const Index = ({ state, setStateFalse }) => {
    const [mail, setMail] = useState(false);
    const [details, setdetials] = useState({
        name: 'Joe Daniels',
        email: 'joe.nyc.daniels@example.com',
        phone: '+91784653513',
        company: 'XYZ Company',
        brand: 'Adidas',
        gst: '18902OSNEU712',
        accountNumber: '278493763829182',
        accountName: 'Joe Daniels',
        IFSC: 'SBIN0012313',
    });
    const changeHandler = (field, newValue) => {
        setdetials((prev) => {
            const old = { ...prev };
            old[field] = newValue;
            return old;
        });
    };
    return (
        <>
            <SendMail
                setStateFalse={() => {
                    setMail((prev) => !prev);
                }}
                state={mail}
                email="kushagrathreearrow@gmail.com"
            />
            <PopupModal setStateFalse={setStateFalse} state={state}>
                <div className="popupConatiner">
                    <div className="home_head flex-start">
                        <div className="home_head">
                            <div>
                                <h2 className="home_heading">Merchant Details</h2>
                            </div>
                            <div>
                                <p className="home_subtext">Merchant ID: XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</p>
                            </div>
                        </div>
                    </div>
                    <div className="popup_body">
                        <p className="merchant_details_text" style={{ fontSize: '1rem' }}>
                            *The details editable as free flow text.
                        </p>
                        <div className="merchant_details">
                            <div className="merchant_details_left">
                                <h2 className="merchant_details_subheading">Profile Details</h2>
                                <input
                                    value={details.name}
                                    onChange={(e) => {
                                        changeHandler('name', e.target.value);
                                    }}
                                    className="merchant_details_input"
                                    placeholder="Merchant Name Here*"
                                />

                                <input
                                    value={details.email}
                                    onChange={(e) => {
                                        changeHandler('email', e.target.value);
                                    }}
                                    className="merchant_details_input"
                                    placeholder="Merchant Email Here*"
                                />
                                <input
                                    value={details.phone}
                                    onChange={(e) => {
                                        changeHandler('phone', e.target.value);
                                    }}
                                    className="merchant_details_input"
                                    placeholder="Merchant Phone Here*"
                                />
                                <h2 className="merchant_details_subheading">Business Details</h2>
                                <input
                                    value={details.company}
                                    onChange={(e) => {
                                        changeHandler('company', e.target.value);
                                    }}
                                    className="merchant_details_input"
                                    placeholder="Company Name Here*"
                                />
                                <input
                                    value={details.brand}
                                    onChange={(e) => {
                                        changeHandler('brand', e.target.value);
                                    }}
                                    className="merchant_details_input"
                                    placeholder="Comapny Brand Here*"
                                />
                                <input
                                    value={details.gst}
                                    onChange={(e) => {
                                        changeHandler('gst', e.target.value);
                                    }}
                                    className="merchant_details_input"
                                    placeholder="GSTIN Here*"
                                />
                                <h2 className="merchant_details_subheading">Bank Details</h2>
                                <input
                                    value={details.accountName}
                                    onChange={(e) => {
                                        changeHandler('accountName', e.target.value);
                                    }}
                                    className="merchant_details_input"
                                    placeholder="Holder Name Here*"
                                />
                                <input
                                    value={details.accountNumber}
                                    onChange={(e) => {
                                        changeHandler('accountNumber', e.target.value);
                                    }}
                                    className="merchant_details_input"
                                    placeholder="Account Number Here*"
                                />
                                <input
                                    value={details.IFSC}
                                    onChange={(e) => {
                                        changeHandler('IFSC', e.target.value);
                                    }}
                                    className="merchant_details_input"
                                    placeholder="Account IFSC Here*"
                                />
                            </div>
                            <div className="merchant_details_right">
                                <h2 className="merchant_details_subheading">Company's Address</h2>
                                <AddressDetailsPreview isComp />
                            </div>
                        </div>
                        <div className="product_details_right_foot">
                            <button onClick={setStateFalse} style={{ marginRight: 'auto' }} className="btn-gray">
                                <KeyboardBackspaceIcon className="btn-icon" />
                                <p>Back</p>
                            </button>
                            <button
                                onClick={() => {
                                    setMail((prev) => !prev);
                                }}
                                style={{ marginRight: '1rem' }}
                                className="btn-orange"
                            >
                                <MailOutlineIcon className="btn-icon" />
                                <p>Contact Merchant</p>
                            </button>
                            <button className="btn-orange">
                                <SaveIcon className="btn-icon" />
                                <p>Save Details</p>
                            </button>
                        </div>
                    </div>
                </div>
            </PopupModal>
        </>
    );
};

export default Index;
